import React, { createContext, useCallback, useContext, useState } from 'react';

interface IAppBarScrollContextValue {
  scrollTarget: Node | undefined;
  setScrollTarget: (node: Node | null) => void;
}

const AppBarScrollContext = createContext<IAppBarScrollContextValue>({
  scrollTarget: undefined,
  setScrollTarget: () => {},
});

export const AppBarScrollContextProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [scrollTarget, setScrollTargetState] = useState<Node | undefined>(
    undefined
  );

  const setScrollTarget = useCallback((node: Node | null) => {
    setScrollTargetState(node ?? undefined);
  }, []);

  return (
    <AppBarScrollContext.Provider value={{ scrollTarget, setScrollTarget }}>
      {children}
    </AppBarScrollContext.Provider>
  );
};

export const useAppBarScrollContext = (): IAppBarScrollContextValue =>
  useContext(AppBarScrollContext);

export default AppBarScrollContext;
